module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAdCAMAAAA0LHRjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF2erj0Obc29zc9fX16PLsytfQx9DK6enpzd7W+/z71ung4eTj7vbx0dHR////3u7p4PGRwwAAALtJREFUeNq81OEOgyAMRtEPWhBR6fu/7RhIBoszJSa7/49VqiIxRISZ96QLSc5gjAFOTncCclHlUUQtPk0LyLpDRmHuZ0jMl4zCE6INa4cBgk5IPAlYtGFe1CGQif4nMC0250IwUfXoaxVHyXsXdENgj5bTbQSJaFms1QkqokWKF4wHoTrop0JxwtgHoflQeFrkJXbCO/fef86UfpBOHF/5musLwjfiMurvKq2U4yW32dIlgeJPS0MvAQYA89RKSg8os5kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/NE.png
// module id = Y6qv
// module chunks = 1